import { Injectable } from '@angular/core';

import { BaseEditService } from 'tms-lib';
import { CustomerAddress, CustomerAddressEdit } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class CustomerAddressService extends BaseEditService<CustomerAddress, CustomerAddressEdit> {
  constructor() {
    super('CustomerAddress', $localize`Customer Address`);
  }
}
